import React, { useContext, useState, useRef } from 'react';
import { Container, Table, Spinner, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const QuickReport = () => {
	const { getQuickReportLoad, getDate, quickReport, quickReportToday, getQuickReportTodayLoad, quickReportYear, getQuickReportYearLoad, downloadExcel } = useContext(AppContext);
	const [filename] = useState('Quick report');
	const tableRef = useRef(null);

	const formatExcel = () => {
		let data = [];
		const addSection = (title, stats) => {
			if (!stats) return;
			// Add a header/divider row if possible, or just the data. Since standard export might not support mixed types well, we just add the row.
			// Ideally we make the Period the first column.
			data.push({
				'Period': title,
				'Tokens': stats.tokens_created,
				'Bills': stats.bills_generated,
				'Services': stats.services_completed,
				'TC': stats.total_transaction_amount,
				'SC': stats.total_service_amount,
				'Credit': stats.total_credits,
				'Debit': stats.total_debits,
				'Total': stats.total_amount
			});
		};

		if (quickReportToday?.today) addSection('Today', quickReportToday.today);
		if (quickReport) {
			if (quickReport.yesterday) addSection('Yesterday', quickReport.yesterday);
			if (quickReport.this_week) addSection('This Week', quickReport.this_week);
			if (quickReport.last_week) addSection('Last Week', quickReport.last_week);
			if (quickReport.this_month) addSection('This Month', quickReport.this_month);
			if (quickReport.last_month) addSection('Last Month', quickReport.last_month);
		}
		if (quickReportYear?.this_year) addSection('This Year', quickReportYear.this_year);

		return data;
	}

	return (
		<Container className="py-3">
			<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
				<span>Download</span>
				<Button className="br-1" onClick={() => {
					downloadExcel(formatExcel(), `${filename} ${getDate()}.xlsx`);
				}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
				<Button onClick={() => {
					generatePDF(tableRef, { filename: `${filename} ${getDate()}.pdf` });
				}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
				<ReactToPrint
					trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
					content={() => tableRef.current}
				/>
			</div>
			<div ref={tableRef}>
				{
					getQuickReportTodayLoad ? (
						<div className="d-grid py-2">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						quickReportToday !== undefined ? (
							<>
								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >Today</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReportToday.today.tokens_created}</span></td>
											<td><span className="tp2">{quickReportToday.today.bills_generated}</span></td>
											<td><span className="tp2">{quickReportToday.today.services_completed}</span></td>
											<td><span className="tp2">{quickReportToday.today.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReportToday.today.total_service_amount}</span></td>
											<td><span className="tp2">{quickReportToday.today.total_credits}</span></td>
											<td><span className="tp2">{quickReportToday.today.total_debits}</span></td>
											<td className="tp2 text-end"><span>{quickReportToday.today.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
							</>
						) : ''
					)
				}
				{
					getQuickReportLoad ? (
						<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
					) : (
						quickReport !== undefined ? (
							<>

								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >Yesterday</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReport.yesterday.tokens_created}</span></td>
											<td><span className="tp2">{quickReport.yesterday.bills_generated}</span></td>
											<td><span className="tp2">{quickReport.yesterday.services_completed}</span></td>
											<td><span className="tp2">{quickReport.yesterday.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReport.yesterday.total_service_amount}</span></td>
											<td><span className="tp2">{quickReport.yesterday.total_credits}</span></td>
											<td><span className="tp2">{quickReport.yesterday.total_debits}</span></td>
											<td className="tp2 text-end"><span>{quickReport.yesterday.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >This Week</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReport.this_week.tokens_created}</span></td>
											<td><span className="tp2">{quickReport.this_week.bills_generated}</span></td>
											<td><span className="tp2">{quickReport.this_week.services_completed}</span></td>
											<td><span className="tp2">{quickReport.this_week.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReport.this_week.total_service_amount}</span></td>
											<td><span className="tp2">{quickReport.this_week.total_credits}</span></td>
											<td><span className="tp2">{quickReport.this_week.total_debits}</span></td>
											<td className="tp2 text-end"><span>{quickReport.this_week.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >Last Week</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReport.last_week.tokens_created}</span></td>
											<td><span className="tp2">{quickReport.last_week.bills_generated}</span></td>
											<td><span className="tp2">{quickReport.last_week.services_completed}</span></td>
											<td><span className="tp2">{quickReport.last_week.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReport.last_week.total_service_amount}</span></td>
											<td><span className="tp2">{quickReport.last_week.total_credits}</span></td>
											<td><span className="tp2">{quickReport.last_week.total_debits}</span></td>
											<td className="tp2 text-end"><span>{quickReport.last_week.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >This Month</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReport.this_month.tokens_created}</span></td>
											<td><span className="tp2">{quickReport.this_month.bills_generated}</span></td>
											<td><span className="tp2">{quickReport.this_month.services_completed}</span></td>
											<td><span className="tp2">{quickReport.this_month.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReport.this_month.total_service_amount}</span></td>
											<td><span className="tp2">{quickReport.this_month.total_credits}</span></td>
											<td><span className="tp2">{quickReport.this_month.total_debits}</span></td>
											<td className="tp2 text-end"><span>{quickReport.this_month.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >Last Month</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReport.last_month.tokens_created}</span></td>
											<td><span className="tp2">{quickReport.last_month.bills_generated}</span></td>
											<td><span className="tp2">{quickReport.last_month.services_completed}</span></td>
											<td><span className="tp2">{quickReport.last_month.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReport.last_month.total_service_amount}</span></td>
											<td><span className="tp2">{quickReport.last_month.total_credits}</span></td>
											<td><span className="tp2">{quickReport.last_month.total_debits}</span></td>
											<td className="tp2 text-end"><span>{quickReport.last_month.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
							</>
						) : 'Not found!'
					)
				}
				{
					getQuickReportYearLoad ? (
						<div className="d-grid py-2">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						quickReportYear !== undefined ? (
							<>
								<span className="f18 tp2 d-grid bdrb0 px-2 py-1" >This Year</span>
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Tokens</span></th>
											<th><span className="tp2" >Bills</span></th>
											<th><span className="tp2" >Services</span></th>
											<th><span className="tp2" >TC</span></th>
											<th><span className="tp2" >SC</span></th>
											<th><span className="tp2" >Credit</span></th>
											<th><span className="tp2" >Debit</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><span className="tp2">{quickReportYear.this_year.tokens_created}</span></td>
											<td><span className="tp2">{quickReportYear.this_year.bills_generated}</span></td>
											<td><span className="tp2">{quickReportYear.this_year.services_completed}</span></td>
											<td><span className="tp2">{quickReportYear.this_year.total_transaction_amount}</span></td>
											<td><span className="tp2">{quickReportYear.this_year.total_service_amount}</span></td>
											<td><span className="tp2">{quickReportYear.this_year.total_credits}</span></td>
											<td><span className="tp2">{quickReportYear.this_year.total_debits}</span></td>
											<td className="tp2 text-end"><span >{quickReportYear.this_year.total_amount}</span></td>
										</tr>
									</tbody>
								</Table>
							</>
						) : ''
					)
				}
			</div>
		</Container>
	)
}